module.exports = __webpack_public_path__ + "img/1572047572.029be905.jpg";